import React from 'react';

const CommonBannerComponent = ({ header, subTitle }) => {
  const bannerStyles = { backgroundColor: 'white', color: 'black' };

  const headerStyles = { color: 'black' };

  const subTitleStyles = { color: 'black' };

  const processedHeader = header;
  const processedSubTitle = subTitle;

  return (
    <div style={bannerStyles}>
      <div className="container-xxl mt-2">
        <div>
          <h1 className="govuk-heading-xl" style={headerStyles} dangerouslySetInnerHTML={{ __html: processedHeader }} />
          <h2 className="govuk-heading-s" style={subTitleStyles} dangerouslySetInnerHTML={{ __html: processedSubTitle }} />
        </div>
      </div>
    </div>
  );
};

export default CommonBannerComponent;
